var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
export var offer = ['offer'];
export var payment = ['payment'];
export var tariff = ['tariff'];
export var route = ['route'];
export var coupon = ['coupon'];
export var location = ['location'];
export var routeItem = function (index, key) { return __spreadArray(__spreadArray([], route), [index, key]); };
export var requirements = function (deps) { return ['requirements'].concat(deps); };
export var requirementValue = function (deps, name) { return requirements(deps).concat(name); };
